// FILE NOTE: Custom JS file created to not interfere with the theme's JS file. Also incase the theme is updated and theme JS get's overwritten this file will remain untouched.

const emptyComparedSVG = `<svg aria-hidden="true" focusable="false" width="24" height=24" class="compare-button--icon-empty" viewBox="0 0 24 24" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 5.1V18.6771L12 16.1867L17.5 18.6771V5.10001C13.7701 4.3 10.2299 4.29999 6.5 5.1ZM5.57822 3.76994C9.9412 2.74335 14.0588 2.74336 18.4218 3.76994L19 3.90599V21.0029L12 17.8333L5 21.0029V3.90599L5.57822 3.76994Z" fill="currentColor"/>
    </svg>`
const filledComparedSVG = `<svg aria-hidden="true" focusable="false" width="24" height="24" class="hidden compare-button--icon-filled" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.57822 3.76994C9.9412 2.74335 14.0588 2.74336 18.4218 3.76994L19 3.90599V21.0029L12 17.8333L5 21.0029V3.90599L5.57822 3.76994Z" fill="currentColor"/>
    </svg>`

const isMobile = window.innerWidth < 700;


// CLP VIEW ALL BUTTON
window.fetchGraphQL = async function fetchGraphQL(query, variables) {
  const response = await fetch('https://akubra.myshopify.com/api/2025-01/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': 'b7606b76d296ec78701d5efe4dc1ef19',
    },
    body: JSON.stringify({ query, variables })
  });

  const data = await response.json();
  return data
}

async function fetchProducts(collectionHandle, after = null) {

  const query = `
  query ($handle: String!, $after: String) {
    collectionByHandle(handle: $handle) {
      products(first: 250, after: $after) {
        nodes {
          title
          handle
          onlineStoreUrl
          tags
          images(first: 10) {
            nodes {
              originalSrc
            }
          }
          variants(first: 10) {
            nodes {
              price {
                amount
              }
            }
          }
          inner: metafield(namespace: "custom", key: "inner") {
            value
          }
          outer: metafield(namespace: "custom", key: "outer") {
            value
          }
          colour: metafield(namespace: "custom", key: "colour") {
            value
          }
          lining: metafield(namespace: "custom", key: "lining") {
            value
          }
          eyelets: metafield(namespace: "custom", key: "eyelets") {
            value
          }
          brim: metafield(namespace: "custom", key: "brim") {
            value
          }
          crown: metafield(namespace: "custom", key: "crown") {
            value
          }
          crown_type: metafield(namespace: "custom", key: "crown_type") {
            value
          }
          binding: metafield(namespace: "custom", key: "binding") {
            value
          }
          category: metafield(namespace: "custom", key: "category") {
            value
          }
          year_created: metafield(namespace: "custom", key: "year_created") {
            value
          }
          similar_style: metafield(namespace: "custom", key: "similar_style") {
            value
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }`;

  const variables = {
    handle: collectionHandle,
    after,
  };

  return fetchGraphQL(query, variables);
}

function getProductImages(product) {
  // Set default values to avoid broken images
  let productImage = product?.images?.nodes?.[1]?.originalSrc || "";
  let femaleFrontImage = product?.images?.nodes?.[1]?.originalSrc || "";
  let maleFrontImage = product?.images?.nodes?.[1]?.originalSrc || "";
  let kidFrontImage = product?.images?.nodes?.[1]?.originalSrc || "";

  // Iterate through images to set correct model toggle values
  product?.images?.nodes.forEach(({ originalSrc }) => {
    if (originalSrc.includes("product")) {
      productImage = originalSrc;
    } else if (originalSrc.includes("female-front")) {
      femaleFrontImage = originalSrc;
    } else if (originalSrc.includes("male-front")) {
      maleFrontImage = originalSrc;
    } else if (originalSrc.includes("kids-front")) {
      kidFrontImage = originalSrc;
    }
  });

  return { female: femaleFrontImage, male: maleFrontImage, kid: kidFrontImage, product: productImage };
}

function getBadgeData(product, badgeData) {
  let productBadge = null;
  let productIconColour = '';
  let badgeText = '';

  for (const tag of product?.tags || []) {
    if (tag.startsWith('badge:')) {
      productBadge = tag.split('badge:')[1].trim();
    }
    if (tag.startsWith('plp-badge-colour:')) {
      productIconColour = tag.split('plp-badge-colour:')[1].trim();
    }

    if (productBadge && productIconColour) {
      break;
    }
  }

  badgeData?.forEach(badge => {
    if (productBadge === badge.badge_id) {
      badgeText = badge.badge_text;
    }
  });

  return { badgeText, productIconColour };
}

function generateBadgeHTML(badgeText, productIconColour) {
  if (!badgeText) return '';

  const inlineStyle = productIconColour
    ? `style="border-color: ${productIconColour}; color: ${productIconColour};"`
    : '';

  return `
    <div class="badge-container">
      <span class="badge text-xxxxxxs ${productIconColour ? 'badge-custom__colour' : ''}" ${inlineStyle}>
        ${badgeText}
      </span>
    </div>
  `;
}



function generateCompareButtonHTML(showCompare, productIconColour, product) {
  if (!showCompare) return '';
  const productMetafieldData = {
    handle: product?.handle,
    inner: product?.inner?.value,
    outer: product?.outer?.value,
    colour: product?.colou?.value,
    lining: product?.lining?.value,
    eyelets: product?.eyelets?.value,
    brim: product?.brim?.value,
    crown: product?.crown?.value,
    crown_type: product?.crown_type?.value,
    binding: product?.binding?.value,
    category: product?.category?.value,
    year_created: product?.year_created?.value,
    similar_style: product?.similar_style?.value
  };

  return `
    <button class="compare-button product-card__compare-button product-card__compare-button-custom-colour" 
      data-product-handle="${product.handle}" 
      data-product-metafields='${JSON.stringify(productMetafieldData)}'>
      ${emptyComparedSVG.replace('<svg', `<svg style="color: ${productIconColour || '#000'};"`)}
      ${filledComparedSVG.replace('<svg', `<svg style="color: ${productIconColour || '#000'};"`)}
    </button>
  `;
}

function generateProductCardHTML(product, images, selectedValue, badgeHTML, compareButtonHTML) {
  return `
    <product-card class="product-card view-all__product-card">
      <a href="${product?.onlineStoreUrl}" class="product-card__media">
        ${["female", "male", "kid", "product"].map(type => {
    const isHidden = selectedValue === type ? "" : "hidden";
    return `
            <div data-type="${type}" class="photo ${isHidden}">
              <img 
                src="${images[type]}" 
                srcset="
                  ${images[type]}?width=320 320w,
                  ${images[type]}?width=480 480w,
                  ${images[type]}?width=768 768w,
                  ${images[type]}?width=1024 1024w
                "
                sizes="(max-width: 768px) 100vw, 50vw"
                alt="${product?.title} - ${type}" 
                class="product-card__image"
              />
            </div>
          `;
  }).join("")}
      </a>
      <div class="product-card__info">
        <div class="v-stack w-full">
          <a href="${product?.onlineStoreUrl}" class="product-title text-xxs block w-full text-start text-gray-100 font-serif">
            ${product?.title}
          </a>
          <sale-price class="text-start text-gray-70 text-xxxxs">
            $${product?.variants?.nodes[0]?.price?.amount}
          </sale-price>
        </div>
        ${badgeHTML}
      </div>
      ${compareButtonHTML}
    </product-card>
  `;
}

function createProductCard(product, selectedValue, badgeData, showCompare = true) {
  const images = getProductImages(product);
  const { badgeText, productIconColour } = getBadgeData(product, badgeData);
  const badgeHTML = generateBadgeHTML(badgeText, productIconColour);

  const compareButtonHTML = generateCompareButtonHTML(showCompare, productIconColour, product);

  return generateProductCardHTML(product, images, selectedValue, badgeHTML, compareButtonHTML);
}


function createEmptyProductCard() {
  return `
    <product-card class="product-card-empty"></product-card>
  `;
}

async function getProductsFromCollection(collectionHandle, selectedValue, productGridFiller, badgeData, productList, alteredProductListCount) {
  let allProducts = [];
  let response = true;
  let afterCursor;

  while (response) {
    const result = await fetchProducts(collectionHandle, afterCursor);
    const products = result.data.collectionByHandle.products;
    allProducts.push(...products.nodes);

    response = products.pageInfo.hasNextPage;
    afterCursor = products.pageInfo.endCursor;
  }

  if (alteredProductListCount) {

    // This will remove the empty product cards from the end of the initial product list
    const children = productList.children;
    if (children.length >= 2) {
      productList.removeChild(children[children.length - 1]); // Remove the last empty product card
      productList.removeChild(children[children.length - 1]); // Remove the second last empty product card which has become the last one
    }


    for (let i = alteredProductListCount; i < allProducts.length; i++) {
      const product = allProducts[i];
      productList.insertAdjacentHTML('beforeend', createProductCard(product, selectedValue, badgeData));
    }

    // This will fill the empty spots at the end of the grid to make sure lines are calculated correctly
    if (productGridFiller?.remainder > 0) {
      for (let i = 0; i <= productGridFiller.missing_items; i++) {
        productList.insertAdjacentHTML('beforeend', createEmptyProductCard());
      }
    }

    let paginationContainer = document.querySelector('.pagination__container');
    paginationContainer.classList.add('hidden')
    paginationContainer.classList.remove('flex')
  }

  // Below we are adding empty product cards to make sure the layout is correct, if missing products in a row the grid lines can't be calculated correctly (technical limitation)
  const totalProducts = allProducts.length
  const itemsPerRow = window.innerWidth >= 1000 ? 3 : window.innerWidth >= 700 ? 2 : 1;
  const remainder = totalProducts % itemsPerRow;
  const missingItems = remainder === 0 ? 0 : itemsPerRow - remainder;

  if (missingItems > 0) {
    for (let i = 0; i < missingItems; i++) {
      productList.insertAdjacentHTML('beforeend', createEmptyProductCard());
    }
  }
}


/*
  RICH TEXT EDITOR - ADDING CUSTOM STYLES
  - This is used to replace text surrounded by square brackets with a span element with a class of font-cursive

  To use this, paste the below code into the liquid file where you want to use it and update the querySelectorAll to target the correct element.

  <script>
    document.addEventListener('DOMContentLoaded', function() {
      var element = document.querySelectorAll(".slideshow__slide-content .section-title")
      replaceText(element);
    });
  </script>
*/

function replaceText(elements) {
  if (!elements || elements.length === 0) return;

  elements.forEach((element) => {
    let isH1 = element.tagName.toLowerCase() === 'h1' || element.classList.contains('h1');

    element.innerHTML = element.innerHTML.replace(/\[(.*?)\]/g, (match, originalWord) => {
      let spanClass = "font-cursive font-350";
      if (isH1) {
        spanClass += " lowercase";
      }

      return `<span class="${spanClass}">${originalWord}</span>`;
    });
  });
}



// Utilised to adjust the drawers position from the top of the page, considers announcement bar and header sizes 
function adjustDrawerPosition(buttonSelector, shadowHostId) {
  const button = document.querySelector(buttonSelector);

  button.addEventListener('click', () => {
    let headerHeight = 114;
    let announcementHeight = 60;

    const shadowHost = document.querySelector(shadowHostId);
    const shadowRoot = shadowHost.shadowRoot;
    const baseDiv = shadowRoot.querySelector('div[part="base"]');

    const distanceFromTop = window.scrollY;
    const windowWidth = window.innerWidth;

    // Adjust heights based on the window width
    if (windowWidth > 700 && windowWidth < 1000) {
      headerHeight = 68;
    } else if (windowWidth < 700) {
      headerHeight = 54;
      announcementHeight = 50;
    }

    // Set the top position based on scroll distance
    if (distanceFromTop >= announcementHeight) {
      baseDiv.style.top = `${headerHeight}px`;
    } else {
      baseDiv.style.top = `${headerHeight + (announcementHeight - distanceFromTop)}px`;
    }
  });
}


//  FIND IN STORE DRAWER

const storeAvailabilityQuery = `
query getStoreAvailability($variantId: ID!) {
  node(id: $variantId) {
    ... on ProductVariant {
      storeAvailability(first: 5) {
        edges {
          node {
            available
            location {
              name
            }
          }
        }
      }
    }
  }
}`;

const encodeVariantId = (variantId) => btoa(`gid://shopify/ProductVariant/${variantId}`);

window.findSelectedRadio = function findSelectedRadio(radioButtons, selectedSize) {
  return Array.from(radioButtons).find(
    (button) => button.getAttribute("data-option-value") === selectedSize
  );
}

window.updateStoreAvailability = async function updateStoreAvailability(selectedVariantId, fisDrawer) {
  const encodedVariantId = encodeVariantId(selectedVariantId);
  const variables = { variantId: encodedVariantId };

  try {
    const newStoreData = await fetchGraphQL(storeAvailabilityQuery, variables);
    const accordions = fisDrawer.querySelectorAll(".accordion");

    newStoreData?.data?.node?.storeAvailability?.edges.forEach((storeData) => {
      const { name: locationName } = storeData.node.location;
      const availability = storeData.node.available;

      accordions.forEach((accordion) => {
        const locationNameElement = accordion.querySelector(".fis-drawer__store-title");

        if (locationNameElement?.textContent.trim() === locationName) {
          accordion.querySelector(".fis-drawer__available")?.classList.toggle("hidden", !availability);
          accordion.querySelector(".fis-drawer__available")?.classList.toggle("flex", availability);

          accordion.querySelector(".fis-drawer__not-available")?.classList.toggle("hidden", availability);
          accordion.querySelector(".fis-drawer__not-available")?.classList.toggle("flex", !availability);

        }
      });
    });
  } catch (error) {
    console.error("Error fetching store availability:", error);
  }
}

// Will update both Desktop and Mobile size selectors
window.handleRadioChange = function handleRadioChange(event, fisDrawer) {
  const selectedLabel = fisDrawer.querySelectorAll(`label[for="${event.target.id}"]`)
  const selectedInputs = fisDrawer.querySelectorAll(`input[value="${event.target.value}"]`);

  fisDrawer.querySelectorAll("label").forEach((label) => label.classList.remove("selected"));

  selectedLabel.forEach((label) => label.classList.add("selected"));
  isMobile ? selectedInputs[1].click() : selectedInputs[0].click()

  // Update store availability based on selected variant
  window.updateStoreAvailability(event.target.dataset.variantId, fisDrawer);
}

window.handleDrawerClose = function handleDrawerClose(fisDrawer) {
  let selectedRadio = isMobile ? fisDrawer.querySelectorAll('.fis-drawer__mobile-size-variants input[type="radio"][name="size"]:checked') : fisDrawer.querySelectorAll('.fis-drawer__desktop-size-variants input[type="radio"][name="size"]:checked');
  selectedRadio = selectedRadio.length > 0 ? selectedRadio[0] : null;
  if (!selectedRadio) return;

  const selectedValue = selectedRadio.value || selectedRadio.dataset.value;
  const container = document.querySelector(".product-info__block-item .variant-picker__option-values");
  if (!container || !selectedValue) return;

  const relatedInput = container.querySelector(`input[value="${selectedValue}"]`);
  if (relatedInput) {
    relatedInput.click();
  }
}

// Function that runs on page load to select the radio button
window.selectRadioOnLoad = function selectRadioOnLoad(fisDrawer, productVariant) {
  const selectedSize = productVariant.title;
  const radioButtons = isMobile ? fisDrawer.querySelectorAll('.fis-drawer__mobile-size-variants input[type="radio"][name="size"]') : fisDrawer.querySelectorAll('.fis-drawer__desktop-size-variants input[type="radio"][name="size"]');
  if (radioButtons.length === 0) return;

  const selectedRadio = findSelectedRadio(radioButtons, selectedSize);
  if (selectedRadio) {
    selectedRadio.click();
  }
}

window.setupRadioButtons = function setupRadioButtons(fisDrawer) {
  const radioButtons = fisDrawer.querySelectorAll('input[type="radio"][name="size"]')
  radioButtons.forEach((button) =>
    button.addEventListener("change", (event) => handleRadioChange(event, fisDrawer))
  );
}

window.setupDrawerClose = function setupDrawerClose(fisDrawer) {
  const shadowRoot = fisDrawer?.shadowRoot;

  if (!shadowRoot) return;

  const targetElement = shadowRoot.querySelector('[part="overlay"]');
  if (targetElement) {
    targetElement.addEventListener("click", () => handleDrawerClose(fisDrawer));
  }


  const defaultCloseButton = shadowRoot.querySelector("dialog-close-button")
  if (defaultCloseButton) {
    defaultCloseButton.style.display = "none";
  }

  const closeButton = fisDrawer.querySelector(".drawer-close-button");
  if (closeButton) {
    closeButton.addEventListener("click", () => handleDrawerClose(fisDrawer));
  }
}

// Model toggle
window.modelToggleValue = function modelToggleValue() {
  // Get URL parameters
  const url = new URL(window.location);
  const urlParams = url.searchParams;
  const toggleValue = urlParams.get("toggle");
  const expectedToggleValues = ["female", "male", "kid", "product"]

  // Store toggle value from URL if it exists in the expected toggle array
  if (expectedToggleValues.includes(toggleValue)) {
    localStorage.setItem("modelToggleOption", toggleValue);
  }
}

// Remove toggle parameter if user selects their own option
window.removeUrlToggleParam = function removeUrlToggleParam() {
  const url = new URL(window.location);
  const urlParams = url.searchParams;

  if (urlParams.has("toggle")) {
    urlParams.delete("toggle");
    window.history.replaceState({}, document.title, `${url.pathname}${url.search.toString()}`);
  }
}

// Gift note app cart attribute keys (Trace app — populates cart-drawer__gift-note).
const GIFT_NOTE_ATTR_KEYS = [
  "giftnote_to",
  "giftnote_message",
  "giftnote_from",
  "giftnote_medium",
  "giftnote_email",
  "giftnote_phone",
  "giftnote_method",
  "giftnote_time",
  "giftnote_source",
];

// When a gift card is in the cart, the cart-drawer__gift-note element is
// removed (see cart-drawer.liquid). Any leftover gift note app attrs are cleared.
window.cleanupGiftNoteAttrsIfGiftCard = async function cleanupGiftNoteAttrsIfGiftCard(cart) {
  try {
    if (!cart) {
      cart = await fetch("/cart.js").then((response) => response.json());
    }

    const hasGiftCard = (cart.items || []).some((item) => item.gift_card === true);
    if (!hasGiftCard) return;

    const attributes = cart.attributes || {};
    const hasGiftNoteAttrs = GIFT_NOTE_ATTR_KEYS.some((key) => attributes[key] != null && attributes[key] !== "");
    if (!hasGiftNoteAttrs) return;

    const clearedAttributes = Object.fromEntries(GIFT_NOTE_ATTR_KEYS.map((key) => [key, null]));
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: clearedAttributes }),
    });
  } catch (error) {
    console.error("Failed to clear gift note cart attributes", error);
  }
}

document.addEventListener("DOMContentLoaded", () => window.cleanupGiftNoteAttrsIfGiftCard());
document.addEventListener("cart:change", (event) => window.cleanupGiftNoteAttrsIfGiftCard(event.detail?.cart));
/*
 * Discount code visibility and removal in the cart.
 *
 * The theme renders cart.cart_level_discount_applications as a read-only badge, and Liquid has no
 * cart.discount_codes property, so a code that is held but not yet allocated is invisible and
 * unremovable. That is the state that traps buyers: the gift-card checkout validation rejects
 * /cart/add.js while a code is applied, and on an empty cart there is no checkout to reach, so the
 * code chip at checkout (the only removal control that exists) is out of reach.
 *
 * /cart.js is the only source that reports held codes, including applicable: false, hence client side.
 */
class CartDiscountCodes extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    const { signal } = this.abortController;

    document.addEventListener("cart:change", () => this.render(), { signal });
    document.addEventListener("cart:refresh", () => this.render(), { signal });

    this.render();
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  async render() {
    let cart;

    try {
      // cache: no-store because the browser will otherwise serve a stale /cart.js straight after a
      // removal, leaving a row on screen for a code that is already gone.
      cart = await (await fetch(`${Shopify.routes.root}cart.js`, { cache: "no-store" })).json();
    } catch (error) {
      console.error("Failed to read cart discount codes", error);
      return;
    }

    this.codes = cart.discount_codes || [];
    // Allocated amounts come from the same payload, keyed by title. This element replaces the Liquid
    // cart_level_discount_applications loop that used to render the amount, rather than sitting beside
    // it and showing the same code twice.
    this.allocations = new Map(
      (cart.cart_level_discount_applications || []).map((application) => [
        application.title,
        application.total_allocated_amount,
      ])
    );

    this.replaceChildren(...this.codes.map((entry) => this.row(entry)));
    this.hidden = this.codes.length === 0;
  }

  row({ code }) {
    const row = document.createElement("div");
    const align = this.hasAttribute("center") ? "justify-center" : "justify-start";
    row.className = `h-stack ${align} gap-2 align-center`;

    const badge = document.createElement("span");
    badge.className = "discount-badge text-xxxxxs";
    // textContent, not innerHTML: the code is buyer-supplied via the /discount route.
    badge.textContent = code;
    row.append(badge);

    const allocated = this.allocations.get(code);
    const detail = document.createElement("span");
    detail.className = "text-subdued text-xxxxxs";
    detail.textContent = allocated ? `-${this.money(allocated)}` : "not applied to this cart";
    row.append(detail);

    const remove = document.createElement("button");
    remove.type = "button";
    remove.className = "text-xxxxxs uppercase underline";
    remove.textContent = "remove";
    remove.setAttribute("aria-label", `Remove discount code ${code}`);
    remove.addEventListener("click", () => this.removeCode(code));
    row.append(remove);

    return row;
  }

  // Cart amounts are in cents.
  money(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }

  // Not named remove(): that would shadow HTMLElement.remove() and any theme code calling it on
  // this element would fire a discount update instead of detaching the node.
  async removeCode(code) {
    // update.js replaces the whole set, so send back everything except the one being dropped. An empty
    // string clears them all, which is what the last removal sends.
    const remaining = (this.codes || [])
      .filter((entry) => entry.code !== code)
      .map((entry) => entry.code)
      .join(",");

    try {
      const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ discount: remaining }),
      });
      if (!response.ok) throw new Error(`update.js returned ${response.status}`);
    } catch (error) {
      console.error("Failed to remove discount code", error);
      return;
    }

    // CartDrawer re-renders the drawer on this event (theme.js:4149), which reconnects this element and
    // calls render() again, so there is nothing to do here.
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  }
}

if (!window.customElements.get("cart-discount-codes")) {
  window.customElements.define("cart-discount-codes", CartDiscountCodes);
}
